import { useNavigate, useLocation, Outlet } from "react-router-dom";
import List from "components/list";
import BookmarkDialog from "../work/projects/bookmarks/input";
import BookmartCardRenderer from "@/modules/bookmarks/card-renderer";
import BookmarksLoader from "@/modules/bookmarks/loader";

export default function Bookmarks() {
  const location = useLocation();

  const isDialogOpen = location.pathname.includes("/bookmarks/+");

  const fields = [
    "id",
    "name",
    "logo",
    "project_id",
    "bookmark_folder.id",
    "bookmark_folder.name",
    "bookmark_folder.links.id",
    "bookmark_folder.links.label",
    "bookmark_folder.links.url",
    "bookmark_folder.links.date_created",
    "status",
    "date_created",
  ];

  const filters = {
    status: { _eq: "active" },
    bookmark_folder: {
      links: { _nnull: true },
    },
  };

  return (
    <div className="flex-1 h-full w-full">
      <List
        title="Bookmarks"
        storageKey="bookmarks_list"
        endPoint="projects"
        filters={filters}
        hidePagination={true}
        meta={{ fields }}
        showSearch={false}
        perPage={25}
        
        renderItems={BookmartCardRenderer}
        renderItemsLoader={BookmarksLoader}
      />

      {isDialogOpen && (
        <BookmarkDialog
          bookmark_folder={location.state?.bookmark_folder}
          project_slug={location.state?.project_slug}
          handleClose={`/work/projects/${location.state?.project_slug}/bookmarks/+`}
        />
      )}

      <Outlet />
    </div>
  );
}
